export default {
  administrationMetadata: {
    banned: 'Состояние',
    registrationDate: 'Зарегистрирован',
    lastEnter: 'Посл. вход',
    companies: 'Компании',
    copyLinkSuccess: 'Скопировано в буфер обмена',
    copyUid: 'Скопировать UID в буфер обмена',
    copyMail: 'Скопировать Email в буфер обмена',
    copyLinkFailed: 'Ошибка при копировании email',
    text: 'Полнотекстовый',
    byCompany: 'По компании',
    changeUserData: 'Изменить данные пользователя',
    changeUserName: 'Редактировать ФИО',
    changeEmail: 'Изменение email',
    newEmail: 'Новый email',
    ban: 'Заблокировать',
    unban: 'Разблокировать',
    setImp: 'Выдать роль для входа от имени другого пользователя',
    unsetImp: 'Забрать роль для входа от имени другого пользователя',
    impersonate: 'Войти под этим пользователем',
    imp: 'Имперс.',
    platformAdmin: 'Адм.платформы',
    admin: 'Администратор',
    platformAdminHint: 'Пользователь получит доступ к разделу «Администрирование» в боковом меню',
    adminHint:
      'Пользователь получит возможность просматривать все страницы платформы, но не дает возможности авторизации под другими учетными записями',
    impHint:
      'Пользователь получит возможность авторизовываться под учетными записями других пользователей',
    setAdmin: 'Выдать роль администратора',
    unsetAdmin: 'Забрать роль администратора',
    setPlatformAdmin: 'Выдать роль администратора платформы',
    unsetPlatformAdmin: 'Забрать роль администратора платформы',
    successMessages: {
      changeUserName: 'Данные пользователя успешно обновлены',
    },
    errorMessages: {
      changeUserName: 'Данные введены неверно',
    },
  },
};
